import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {pushEdapEvent} from '../../../utils/edap';
import EdapViewTracker from '../../common/edap-view-tracker/EdapViewTracker';

import {CardCarousel} from '../../common/carousel/Carousel';
import {RatioCard} from '../../common/carousel/Card';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {TABLET_BREAKPOINT} from '../../../utils/constants';

import {fetchImagesByTags} from '../../../actions/property-type-images';

const ACTION_LOCATION = 'property-types-module';

const has = (key) => (obj) => Boolean(obj[key]);

export function handlerClick(propertyType, index) {
    const eventOptions = {
        actionlocation: ACTION_LOCATION,
        eventrefinements: `${propertyType},position:${index}`
    };

    return () => pushEdapEvent('search.link.click', eventOptions);
}

function buildImageUrl(img) {
    return (res) => (img || '').replace('${templateId}', `carousel-${res}`);
}

function createNewImageCard({isMobile, url, item, linkRel, index}) {
    const {footer, img, link, messageKey, serpLink, title} = item;

    return (
        <RatioCard
            altText={img.altText}
            getImageUrl={buildImageUrl(url)}
            footer={footer}
            fullName={title}
            isMobile={isMobile}
            key={messageKey}
            linkRel={linkRel}
            onClick={handlerClick(link, index)}
            path={serpLink}
            title={title}
        />
    );
}

export class PropertyTypesComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            mounted: false,
            payload: []
        };
    }

    componentDidMount() {
        const {
            basePathPrefix,
            propertyTypes: {items}
        } = this.props;

        if (items) {
            this.props.dispatch(fetchImagesByTags({
                basePathPrefix,
                items
            }));
        }
    }

    handleNext = () => {
        const edapData = {
            actionlocation: ACTION_LOCATION
        };

        pushEdapEvent('nav.next.click', edapData);
    }

    handlePrev = () => {
        const edapData = {
            actionlocation: ACTION_LOCATION
        };

        pushEdapEvent('nav.previous.click', edapData);
    }

    render() {
        const {
            propertyTypes: {title, subtitle, items, imagesUrls},
            isMobile,
            moduleHeading,
            showNewHeadings
        } = this.props;

        if (!items) {
            return null;
        }

        function getImageUrl(item) {
            const match = imagesUrls && imagesUrls.find((img) => img.link === item.link);
            return match ? match.url : null;
        }

        const cards = items
            .filter(has('title'))
            .map((item) => ({item, imageUrl: getImageUrl(item)}))
            .map(({item, imageUrl}, index) =>
                createNewImageCard({
                    isMobile,
                    item,
                    url: imageUrl,
                    linkRel: index <= 2 ? '' : 'nofollow',
                    index: index + 1
                })
            );

        if (cards.length === 0) {
            return null;
        }

        return (
            <div className="container module module--no-padding property-types-ratio-cards">
                {showNewHeadings && <h2 className="page-heading heading--with-padding">{moduleHeading}</h2>}
                {showNewHeadings && <h3 className="page-subheading heading--with-padding">{title}</h3>}
                <CardCarousel
                    titleMessage={showNewHeadings ? null : title}
                    subtitleMessage={subtitle}
                    onNextClick={this.handleNext}
                    onPreviousClick={this.handlePrev}
                >
                    {cards}
                </CardCarousel>
                <EdapViewTracker eventData={{actionlocation: ACTION_LOCATION}} />
            </div>
        );
    }
}

export function mapStateToProps({abacus, config, destination, modules}) {
    return {
        abacus,
        basePathPrefix: config.url.basePathPrefix,
        isMobile: config.isMobile,
        lbsId: destination.details.lbsId,
        propertyTypes: modules.propertyTypes,
        moduleHeading: modules.pageHeadings.propertyTypes,
        showNewHeadings: modules.pageHeadings.showNewHeadings
    };
}

export const PropertyTypes =
    connect(mapStateToProps)(determineIfMobile(PropertyTypesComponent, TABLET_BREAKPOINT));

PropertyTypes.displayName = 'PropertyTypes';

export default PropertyTypes;
